import { render } from "./Correct.vue?vue&type=template&id=45e94073"
import script from "./Correct.vue?vue&type=script&lang=js"
export * from "./Correct.vue?vue&type=script&lang=js"

import exportComponent from "D:\\All\\Job freelance\\CRA-brainy\\Develop\\cra-brainy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__